import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const sentenceInfosResolver: FieldResolver = (metadata: Metadata) =>
  ({ sentenceInfos: metadata.getSentenceInfos() } as StreamData)

export default sentenceInfosResolver
